import { Server } from "../../utils/server";
import { CREATE_PAYMENT_INTENT } from "../../constants/paths";
import { paymentIntentSuccess } from "../actions/payment-intent-actions";

export const createPaymentIntent = (provider) => (dispatch) => {
  return Server({
    method: "post",
    url: CREATE_PAYMENT_INTENT,
    data: { provider },
  })
    .then(function (response) {
      dispatch(paymentIntentSuccess(response.data));
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
